import type {
  RetryWorkerMessage,
  RoastUploadMessage,
  RoastUploadWorkerMessage,
  UploadWorkerMessage
} from './types';

class RoastWorkerManager {
  private worker: Worker | null = null;
  private subscribers: Map<string, (data: RoastUploadWorkerMessage) => void> = new Map();

  constructor() {
    if (!this.worker) {
      import('$lib/roasting/roastUploader.worker?worker')
        .then((SyncWorker) => {
          this.worker = new SyncWorker.default();
          this.worker.onmessage = (data) => this.onmessage(data);
        })
        .catch((error) => {
          throw new Error(`Failed to load upload worker: ${error.message}`);
        });
    }
  }

  // Callback triggered when the worker posts a message to communicate back to the caller.
  private onmessage(event: { data: RoastUploadWorkerMessage }) {
    for (const [key, callback] of this.subscribers) {
      callback(event.data);
    }
  }

  subscribe(type: string, callback: (data: any) => void) {
    console.debug(`Subscribing ${type} to upload worker manager.`);
    this.subscribers.set(type, callback);
  }

  unsubscribe(type: string) {
    this.subscribers.delete(type);
  }

  saveNewRoast(message: RoastUploadMessage) {
    if (!this.worker) {
      throw new Error('RoastWorker is null');
    }

    this.worker.postMessage({
      type: 'upload',
      payload: message
    } as UploadWorkerMessage);
  }

  retryUpload(id: string) {
    if (!this.worker) {
      throw new Error('RoastWorker is null');
    }
    this.worker.postMessage({
      type: 'retryFailed',
      id: id
    } as RetryWorkerMessage);
  }
}

const roastWorkerManager = new RoastWorkerManager();

export default roastWorkerManager;
